export default "__VITE_ASSET__T7LIqZpb__"